module.exports = __webpack_public_path__ + "static/media/job_modal_top.23884f28.svg";